import React from 'react'
import SiteGrid from "../ui/SiteGrid"
import aboutImg from 'app/assets/images/about-img-1.jpg'
import AppButton from "../ui/AppButton"
import SquareGrid from "../ui/SquareGrid"

export default function AboutUs() {

  return (
    <div className="about-section home-section">
      <SiteGrid className="about-flex">
        <div className="img-container">
          <img src={aboutImg} alt="About Us" />
        </div>
        <div className="text-container">
          <h6 className="title">About Us</h6>
          <h2 className="title">Leading the Way in Healthcare</h2>
          <p>
            Our Vision for a Healthier World" reflects a healthcare 
            organization's commitment to setting the standard for 
            excellence. By leveraging technology, research, and talented 
            healthcare professionals, these organizations aim to provide 
            the best possible care and drive improvements in the industry.
            <br/><br/>
            Organizations that lead the way in healthcare promote preventive 
            health measures, educate patients and communities, and address 
            social determinants of health to create a better, healthier 
            world for everyone.
          </p>
          <AppButton
            label="Learn More"
            url="/about/our-story"
            buttonType="outlineBtn animate"
          />
        </div>
      </SiteGrid>
      <div className="circle-1 circle"/>
      <div className="circle-2 circle"/>
      <div className="circle-3 circle"/>
      <SquareGrid className="square-grid-1"/>
      <SquareGrid 
        className="square-grid-2"
        columns={5}
        number={25}
      />
    </div>
  )
}
